export default class ListConfig {
  constructor (listmethod, singlemethod, params, controller) {
    this.listMethod = listmethod;
    this.singleMethod = singlemethod;
    this.params = params;
    this.link = null;
    this.controller = controller ? controller : `/mvc/listinput/`;
  }

  /**
   * @param { ListLink } listlink
   * @memberof ListConfig
   */
  setLink (listlink) {
    this.link = listlink;
  }
  /**
   * @param { ListLink } listlink
   * @memberof ListConfig
   */
  getInstance () {
    let copy = new ListConfig(this.listMethod, this.singleMethod, this.params);
    return copy;
  }
}
export class ArchiveListConfig extends ListConfig {
  constructor  (listmethod, singlemethod, params) {
    super(listmethod, singlemethod, params);
    this.isArchiveList = true;
  }
  /**
   * @param { ListLink } listlink
   * @memberof ListConfig
   */
  getInstance () {
    let copy = new ArchiveListConfig(this.listMethod, this.singleMethod, this.params);
    return copy;
  }
}